/**
 * The fields a submitted transaction's queued copy takes: what the submit sends, and for what it
 * leaves out, the transaction as it is now (`current`, null for a new one). A delete or an undo sends
 * only `id` and `deleted`, so everything else comes from `current`.
 *
 * `deleted` is taken whenever it is sent, false included: an undo sends false, and the copy is what
 * gets posted, so falling back to `current` there would delete the transaction again.
 * `category_id` 0 is a real value too (no category), so only null and undefined fall back.
 */
export default function submittedTransactionFields(data, current) {
	return {
		id: data.id || current?.id,
		category_id: data.category_id ?? current?.category_id,
		where: data.where || current?.where,
		description: data.description || current?.description,
		plaid_transaction_id: data.plaid_transaction_id || current?.plaid_transaction_id,
		transaction_date: data.transaction_date || current?.transaction_date,
		deleted: data.deleted ?? current?.deleted,
	};
}
